import React, { useEffect, useState } from "react";
import usePageContent from "../../hooks/usePageContent";

import "../../app/styles/home.css"
//import "../../app/styles/students.css"

import EditableSection from "../../components/CMS/EditableSection";
import HeroEditor from "../../components/CMS/editors/HeroEditor";
import HeroSection from "../components/HeroSection";
import ProgramsSection from "../components/ProgramsSection";
import CompetitionSection from "../components/CompetitionSection";
import CTASection from "../components/CTASection";
import PlatformSection from "../components/PlatformSection";
import RobotsSection from "../platform/PlatformRobotSection";
import PathwaysSection from "../components/PathwaysSection";
import CapabilitiesSection from "../components/CapabilitiesSection";
import AchievementsSection from "../components/AchievementsSection";
import TimelineSection from "../components/TimelineSection";
import PartnersSection from "../components/PartnersSection";
import FounderTeamSection from "../founder/FounderTeamSection";

import GenericSectionEditor from "../../components/CMS/editors/GenericSectionEditor";


const HomePage = ({ user }) => {
    const {
        get,
        loading,
        error,
        refresh
    } = usePageContent("home");

    // Replace with your actual authentication/user context
    const editable = user?.role === "admin";

    const hero = get("hero");


    if (loading && !hero.title) {
        return <div>Loading...</div>;
    }

    if (error && !hero.title) {
        return <div>Error: {error}</div>;
    }
    return (
        <>
            {/* <Navebar data={get("navbar")}></Navebar> */}

            <EditableSection
                uniqueId="home-hero"
                title="Hero"
                data={get("hero")}
                Display={HeroSection}
                Editor={HeroEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="home-competitions"
                title="Competitions"
                data={get("competitions")}
                Display={CompetitionSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="home-programs"
                title="Programs"
                data={get("programs")}
                Display={ProgramsSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="home-platform"
                title="Platform"
                data={get("platform")}
                Display={PlatformSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="platform-robots"
                title="Robots"
                data={get("robots")}
                Display={RobotsSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="home-pathways"
                title="Pathways"
                data={get("pathways")}
                Display={PathwaysSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="home-capabilities"
                title="Capabilities"
                data={get("capabilities")}
                Display={CapabilitiesSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="home-achievements"
                title="Achievements"
                data={get("achievements")}
                Display={AchievementsSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="home-timeline"
                title="Timeline"
                data={get("timeline")}
                Display={TimelineSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="home-partnerships"
                title="Global Partners"
                data={get("partnerships")}
                Display={PartnersSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />
            <EditableSection
                uniqueId="founders-team"
                title="Founding Family"
                data={get("team")}
                Display={FounderTeamSection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />

            <EditableSection
                uniqueId="home-cta"
                title="Call to Action"
                data={get("cta")}
                Display={CTASection}
                Editor={GenericSectionEditor}
                editable={editable}
                onSaved={refresh}
            />           
        </>
    );
};

export default HomePage;